/* eslint-disable prefer-const */
'use client'; // Error boundaries must be Client Components

import React from 'react';
import {ErrorPage} from '@udemy-v2/react-structure-components';
import {Header} from '@/components/header';
import {Footer} from '@/components/footer';
import {appConfig} from '@/app/lib/app-config';

// Add custom import statements for the 404 page below
// <<Stencil::Block(notFoundPageImports)>>
// <</Stencil::Block>>

export default function NotFound() {
    let errorContent = <ErrorPage />;
    // Override default error content below. Reassign `errorContent` to render a custom element.
    // <<Stencil::Block(notFoundPageContent)>>
    // <</Stencil::Block>>

    return (
        <>
            {!appConfig.useDefaultLayout ? <Header /> : null}
            {errorContent}
            {!appConfig.useDefaultLayout ? <Footer /> : null}
        </>
    );
}
